import React from 'react';
import { Typography } from '@mui/material';
import ShipTable from '../tables/ShipTable';

const ShipSection = () => {
  return (
    <>
      <Typography marginRight={1} marginTop={2} variant='h3'>
        Ship
      </Typography>
      <ShipTable />
    </>
  );
};

export default ShipSection;
